import { EventInfoCard } from "./EventInfoCard";

export default EventInfoCard;
